import { mapActions, mapMutations } from 'vuex'
import get from 'lodash/get'
import { publishService } from '@/api/gig'
import { STATUS_PUBLISHED } from '@/constants/backend/service'
import { SERVICE_CHAT } from '@/constants/routes'
import snackMixin from '@/mixins/snackMixin'
import { googleAnalyticsV2 } from '@/servicies-ts/analytics'
import ErrorMatcher from '@/utils/ErrorMatcher'
import notifiableRequest from '@/utils/notifiableRequest'

export default {
  mixins: [snackMixin],
  methods: {
    ...mapActions({
      executeBtnRequest: 'notifications/executeBtnRequest',
    }),
    ...mapMutations({
      setNotificationData: 'notifications/setNotificationData',
    }),
    gigChatLinkPay(note) {
      return {
        name: SERVICE_CHAT,
        params: { id: note.params.gig.id, slug: note.params.gig.slug },
        query: { room: note.params.room_id, action: 'pay' },
      }
    },
    gigChatLinkRefund(note) {
      return {
        name: SERVICE_CHAT,
        params: { id: note.params.gig.id, slug: note.params.gig.slug },
        query: { room: note.params.room_id, action: 'refund' },
      }
    },
    onPublishGigClick(note) {
      this.executeBtnRequest({
        id: note.id,
        isFirstBtn: false,
        request: () =>
          notifiableRequest({
            title: 'Publish Gig',
            successText: `Gig was successfully published`,
            failureText: (e) => {
              const defaultErr = 'Gig publishing error'
              return ErrorMatcher.isConflict(e) ? get(e, 'response.data.message', defaultErr) : defaultErr
            },
            request: async () => {
              await publishService(note.params.gig?.id)
              googleAnalyticsV2.send({
                event: 'gig-published',
                gig_id: note.params.gig?.id,
              })
              this.setNotificationData({ id: note.id, path: 'params.gig', property: 'status', data: STATUS_PUBLISHED })
            },
          }),
      })
    },
    onGigRefundClick(note) {
      this.$router.push(this.gigChatLinkRefund(note))
    },
    onGigPayFreelancerClick(note) {
      this.$router.push(this.gigChatLinkPay(note))
    },
  },
}
